import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=5b909033"
import script from "./qrcode.vue?vue&type=script&lang=js"
export * from "./qrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b909033')) {
      api.createRecord('5b909033', component.options)
    } else {
      api.reload('5b909033', component.options)
    }
    module.hot.accept("./qrcode.vue?vue&type=template&id=5b909033", function () {
      api.rerender('5b909033', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/componentsUI/qrcode.vue"
export default component.exports